/**
 * − / + buttons for server-rendered quantity steppers ([data-amp-stepper]).
 *
 * The input is a plain number field, so the form still works without this.
 * Buttons carry data-amp-step="-1" / "1" and respect the input's min/max.
 */
function clamp(input, value) {
	const min = input.min !== "" ? Number(input.min) : 1;
	const max = input.max !== "" ? Number(input.max) : Infinity;
	return Math.min(max, Math.max(min, value));
}

function sync(stepper) {
	const input = stepper.querySelector("input");
	if (!input) return;
	const value = Number(input.value) || 0;
	stepper.querySelectorAll("[data-amp-step]").forEach((btn) => {
		const step = Number(btn.dataset.ampStep);
		btn.disabled = clamp(input, value + step) === value;
	});
}

/**
 * Re-clamp and refresh a stepper after its input was changed from outside,
 * e.g. WooCommerce's variation script rewriting min/max through jQuery (which
 * native change listeners don't hear).
 */
export function syncStepper(stepper) {
	const input = stepper?.querySelector("input");
	if (!input) return;
	if (input.value !== "") input.value = String(clamp(input, Math.round(Number(input.value) || 0)));
	sync(stepper);
}

export function initSteppers() {
	document.querySelectorAll("[data-amp-stepper]").forEach(sync);

	document.addEventListener("click", (e) => {
		const btn = e.target.closest("[data-amp-stepper] [data-amp-step]");
		if (!btn) return;

		const stepper = btn.closest("[data-amp-stepper]");
		const input = stepper.querySelector("input");
		if (!input) return;

		const next = clamp(input, (Number(input.value) || 0) + Number(btn.dataset.ampStep));
		input.value = String(next);
		input.dispatchEvent(new Event("change", { bubbles: true }));
		sync(stepper);
	});

	document.addEventListener("change", (e) => {
		const stepper = e.target.closest?.("[data-amp-stepper]");
		if (!stepper || e.target.tagName !== "INPUT") return;
		const input = e.target;
		const clamped = clamp(input, Math.round(Number(input.value) || 0));
		if (String(clamped) !== input.value) input.value = String(clamped);
		sync(stepper);
	});

	// The add-to-cart module blanks grouped rows once they're in the cart, just
	// after it fires this event — put the zero back and refresh the buttons.
	document.body.addEventListener("wc-blocks_added_to_cart", () => {
		setTimeout(() => {
			document.querySelectorAll("[data-amp-stepper]").forEach((stepper) => {
				const input = stepper.querySelector("input");
				if (input && input.value === "" && input.min === "0") input.value = "0";
				sync(stepper);
			});
		}, 0);
	});
}
